import React from "react";
import { Button } from "@catchoftheday/cg-components";
import { styled, themeGet } from "@catchoftheday/theme";
const ButtonWithUnderlineText = styled(Button) `
  text-decoration: underline;
  &:hover,
  &:focus {
    color: ${themeGet("colors.typography.linkHover")} !important;
  }
`;
export const OnePassCTAButton = (props) => (<ButtonWithUnderlineText variant="plain" padding="0" textAlign="left" textTransform="none" fontSize="12px" fontWeight="bold" border="none" color="onePass.primary" {...props}/>);
